<template>
    <div class="check-step-item check-step-item-1" :class="{'check-step-item-done' : passedStep, 'expand' : expand}">
        <SubscribeCancelWindow @confirmCancel="confirmCancel"/>
        <SaveWindow text="Данные успешно сохранены"/>
        <div class="step-heading" @click="expand = !expand">
            <div v-if="passedStep" class="step-checked-icon">
                <DoneIcon/>
            </div>
            <div class="step-number">Шаг 1</div>
            <div class="step-title">Связаться с Клиентом</div>
        </div>
        <div class="step-content">
            <div class="step-desc">
                Попробуйте установить связь с&nbsp;Клиентом в&nbsp;течение 7&nbsp;дней по&nbsp;любому из&nbsp;указанных
                им&nbsp;каналов связи
            </div>

            <div class="step-checklist">

                <div v-for="step in steps"
                     class="step-checklist-item"
                     :class="{'step-checklist-done': step.passed || passedStep}"
                >
                    <div class="step-checklist-text">День {{ step.dayNumber }}. Удалось связаться с Клиентом?</div>

                    <div class="step-checklist-row step-checklist-row-2">
                        <div class="step-checklist-field">
                            <label @click="stepSuccess(step)">
                                <span class="field-radio-wrapper">
                                    <input v-model="step.contactSuccess"
                                           value="true"
                                           type="radio"
                                           class="step-check-yes" :disabled="step.passed || passedStep">
                                    <span class="field-radio"></span>
                                </span>
                                <span>Да</span>
                            </label>
                        </div>
                        <div class="step-checklist-field">
                            <label @click="showCallAfter = false">
                                <span class="field-radio-wrapper">
                                    <input v-model="step.contactSuccess"
                                           value="false"
                                           type="radio"
                                           class="step-check-no"
                                           :disabled="step.passed || passedStep">
                                    <span class="field-radio"></span>
                                </span>
                                <span>Нет</span>
                            </label>
                        </div>
                    </div>

                    <div v-if="!step.passed && showCallAfter && steps.indexOf(step) === steps.length - 1"
                         class="step-checklist-action">

                        <div class="step-checklist-action-yes">
                            <div class="action-cell action-field">
                                <div class="form-field-input-2">
                                    <label>
                                        Перезвонить через, дней
                                    </label>
                                    <div class="field-input-wrapper">
                                        <input v-model="callAfterDays" @keypress="isNumber" type="text">
                                    </div>
                                </div>
                            </div>
                            <div class="action-cell action-divider">
                                ИЛИ
                            </div>
                            <div class="action-cell action-button">
                                <button @click="cancelSubscription"
                                        class="button button-dark modal-client-check-subscribe-cancel">
                                    Отменить подписку
                                </button>
                            </div>
                        </div>

                    </div>

                </div>

                <div v-if="!passedStep" class="step-checklist-item">
                    <div class="step-checklist-end">
                        <div class="step-checklist-field">
                            <label>
                                <span class="field-check-wrapper">
                                    <input v-model="isDead" :disabled="passedStep" type="checkbox" class="step-action-dead">
                                    <span class="field-check"></span>
                                </span>
                                <span>Удалось выяснить, что Клиент умер</span>
                            </label>
                        </div>
                    </div>

                </div>

            </div>

            <div v-if="!passedStep" class="button-block">
                <button class="button button-dark"
                        :disabled="(showCallAfter === true && callAfterDays === '' && !removeSubscribe && !isDead) || (passedStep)"
                        @click="save">Сохранить
                </button>
            </div>

        </div>
    </div>
</template>

<script>
import rest from '../../restUtils';

import SubscribeCancelWindow from "@/components/windows/SubscribeCancelWindow";
import SaveWindow from "@/components/windows/SaveWindow";
import DoneIcon from "@/components/icons/DoneIcon";

export default {
    name: "FirstStep",
    components: {DoneIcon, SaveWindow, SubscribeCancelWindow},
    props: ['steps', 'passed'],
    data() {
        return {
            showCallAfter: false,
            callAfterDays: '',
            isDead: false,
            removeSubscribe: false,
            passedStep: this.passed,
            expand: false
        }
    },
    created() {
    },

    computed: {},

    watch: {
        steps() {
            if (this.steps.length === 0) {
                this.steps.push({
                    stepNumber: 1,
                    dayNumber: 1,
                    contactSuccess: false,
                    passed: false
                });
            }
        },
        passed() {
            this.passedStep = this.passed;
        }
    },
    methods: {
        stepSuccess(step) {
            if (!step.passed) {
                this.showCallAfter = true;
            }
        },
        async save() {
            let lastStep = this.steps[this.steps.length - 1];
            let dto = {
                step: {
                    id: lastStep.id,
                    stepNumber: 1,
                    dayNumber: lastStep.dayNumber,
                    contactSuccess: lastStep.contactSuccess
                },
                dead: this.isDead,
                callAfterDays: this.callAfterDays,
                stepNumber: 1
            };
            try {
                let result = await rest.doPost("/admin/client/" + this.$route.query.id + "/step", dto);
                lastStep.id = result.savedId;
                if (result.currentStep !== 1) {
                    this.passedStep = true;
                    this.$emit("stepChanged", result.currentStep);
                }

                if (result.currentStep === 1 && dto.step.contactSuccess) {
                    this.steps = [];
                    this.isDead = false;
                    this.showCallAfter = false;
                    this.callAfterDays = '';
                    this.removeSubscribe = false;
                }
                $('.window-wrapper.window-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
            } catch (error) {

            }
        },
        cancelSubscription() {
            $('.window-wrapper.window-client-check-subscribe-cancel').addClass('window-open');
            $('body').addClass('blocked');
        },
        confirmCancel() {
            this.removeSubscribe = true;
            try {
                rest.doPost("/admin/client/" + this.$route.query.id + "/cancelSubscription");
                this.$emit('stepChanged', 0);
            } catch (error) {

            }
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
}
</script>

<style scoped>

</style>